// src/hooks/useAnalytics.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../Firebase/firebase';


const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Log a screen_view event on route change
    logEvent(analytics, 'screen_view', { screen_name: location.pathname });
  }, [location]);
};

export default useAnalytics;
